module.exports = __webpack_public_path__ + "static/img/icon-bind.d3981f1e.png";